var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFavoriteIconBig(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.42937 0.75623C8.60898 0.203444 9.39102 0.203444 9.57063 0.75623L11.1104 5.49524C11.1908 5.74245 11.4211 5.90983 11.6811 5.90983H16.664C17.2452 5.90983 17.4869 6.6536 17.0166 6.99524L12.9854 9.92411C12.7751 10.0769 12.6871 10.3477 12.7674 10.5949L14.3072 15.3339C14.4868 15.8867 13.8541 16.3464 13.3839 16.0048L9.35267 13.0759C9.14238 12.9231 8.85762 12.9231 8.64733 13.0759L4.61609 16.0048C4.14586 16.3464 3.51317 15.8867 3.69278 15.3339L5.23258 10.5949C5.3129 10.3477 5.22491 10.0769 5.01462 9.92411L0.983374 6.99524C0.513146 6.6536 0.754811 5.90983 1.33605 5.90983H6.31893C6.57887 5.90983 6.80924 5.74245 6.88957 5.49524L8.42937 0.75623Z",
    fill: "#FFD23B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoriteIconBig);
export default __webpack_public_path__ + "static/media/favorite_icon-big.70d19b6d3e31dbd7f50bfcfd50500f63.svg";
export { ForwardRef as ReactComponent };